import { Button, Header, Link, SpaceBetween } from "@cloudscape-design/components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useUserProfile } from "../../../components";

export function FormHeader({ loadHelpPanelContent }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { contentLanguage, setContentLanguage } = useUserProfile();

  function goBackToSolutionsPageHandler() {
    navigate(-1);
  }

  const changeContentLanguage = () => {
    setContentLanguage(contentLanguage === "en" ? "cn" : "en");
  };

  return (
    <Header
      variant="h1"
      info={
        <Link onFollow={loadHelpPanelContent} variant="info">
          {t("casestudies:CasestudyCreateForm.linkInfo")}
        </Link>
      }
      description={t("casestudies:CasestudyCreateForm.description")}
      actions={
        <SpaceBetween direction="horizontal" size="xs">
          <Button data-testid="header-btn-go-back" onClick={changeContentLanguage}>
            {contentLanguage === "en" ? t("PageHeader.buttonChangeLanguageCN") : t("PageHeader.buttonChangeLanguage")}
          </Button>
          <Button data-testid="header-btn-go-back" onClick={goBackToSolutionsPageHandler}>
            {t("PageHeader.buttonGoBack")}
          </Button>
        </SpaceBetween>
      }
    >
      {t("casestudies:CasestudyCreateForm.pageHeaderTitle")}
    </Header>
  );
}
